import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { DisableSubscriptionMutation } from "arena/mutations";
import ErrorScreen from "core/components/ErrorScreen";
import { useParams } from "react-router-dom";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";

const Root = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
});

export default function DisableSubscription() {
  const { token } = useParams();
  const { t } = useTranslation("arena");

  const [disableSubscription, { error, data }] = useMutation(
    DisableSubscriptionMutation,
    {
      refetchQueries: ["Viewer"],
      variables: { token },
    }
  );

  useEffect(disableSubscription, []);

  if (error) {
    return (
      <Root>
        <ErrorScreen error={error} />
      </Root>
    );
  }

  if (data) {
    return (
      <Root>
        <ErrorScreen
          icon={NotificationsOffIcon}
          text={t("disableSubscription.success")}
        />
      </Root>
    );
  }

  return (
    <Root>
      <CircularProgress />
    </Root>
  );
}
